import type { Contact } from '../../domain/contact';
import type { CollectedDataItem } from '../../domain/message';
import UrlService from '../UrlService';

import SharedDataExtractionService from './sharedDataExtractionService';

const createMicrosoftDynamicsDataExtractionService = () => {
  const { extractCompanyName, extractContentByKey, extractCompanyDomainFromEmail, extractAttributeValueByKey } =
    SharedDataExtractionService;

  const extractContactInfo = (collectedData: CollectedDataItem[]): Partial<Contact> => {
    const firstName = extractAttributeValueByKey(collectedData, 'First Name', 'value');
    const lastName = extractAttributeValueByKey(collectedData, 'Last Name', 'value');
    const name = firstName && lastName && `${firstName} ${lastName}`;
    const email = extractAttributeValueByKey(collectedData, 'Contact Email', 'value');
    const companyDomainFromEmail = extractCompanyDomainFromEmail(email);
    const companyName = extractContentByKey(collectedData, 'Company Name') as string;

    return {
      name,
      site: companyDomainFromEmail,
      companyName,
    };
  };

  const extractCompanyDomain = (collectedData: CollectedDataItem[]): string | undefined => {
    const websiteElem = collectedData.find(({ name }) => name === 'Company Website');
    if (!websiteElem || !websiteElem.attributes?.['value'] || typeof websiteElem.attributes['value'] !== 'string') {
      return;
    }

    try {
      const { hostname } = new URL(websiteElem.attributes['value']);
      return UrlService.removeWWW(hostname);
    } catch {
      return;
    }
  };

  const extractLeadInfo = (collectedData: CollectedDataItem[]): Partial<Contact> => {
    const fullName = extractContentByKey(collectedData, 'Full Name') as string;
    const firstName = extractAttributeValueByKey(collectedData, 'First Name', 'value');
    const lastName = extractAttributeValueByKey(collectedData, 'Last Name', 'value');
    const name = fullName || (firstName && lastName && `${firstName} ${lastName}`);
    const companyName = extractContentByKey(collectedData, 'Company Name') as string;
    const companyDomain = extractCompanyDomain(collectedData);
    const email = extractAttributeValueByKey(collectedData, 'Contact Email', 'value');
    const companyDomainFromEmail = extractCompanyDomainFromEmail(email);

    return { name, site: companyDomainFromEmail || companyDomain, companyName };
  };

  return { extractCompanyDomain, extractCompanyName, extractContactInfo, extractLeadInfo };
};

const MicrosoftDynamicsDataExtractionService = createMicrosoftDynamicsDataExtractionService();

export default MicrosoftDynamicsDataExtractionService;
